import { setNestedObjectValues } from "formik";

/**
 * Builds the save handler for a formik form.
 *
 * Replaces `formik.isValid ? formik.submitForm : showWarning`, which had two
 * problems: `isValid` is false on a fresh create form before anything has been
 * validated, so the first press could go to the warning branch even on a form
 * the user had filled in; and the warning branch never marked the fields as
 * touched, so the messages stayed hidden and the toast was all the user got.
 *
 * Validating here gives us the error list itself — every field in it is marked
 * touched, which is what makes `FieldError` render the message under the field.
 *
 * @param formik     the object returned by useFormik
 * @param onInvalid  optional, called with the errors when the form can't be sent
 */
export const submitFormik = (formik, onInvalid) => async () => {
  const errors = await formik.validateForm();

  if (Object.keys(errors).length) {
    // `false` — no point revalidating, we already have the errors
    formik.setTouched(setNestedObjectValues(errors, true), false);
    onInvalid?.(errors);
    return;
  }

  await formik.submitForm();
};

export default submitFormik;
